import type { TrackableProduct } from 'types/TrackableProduct';

import {
  type RetailerOption,
  toWireRetailerOption,
  type WireRetailerOption
} from '~/utils/listings';

import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type RetailerTargetProperties = {
  product_id?: string;
  retailer_id?: string;
  retailers: WireRetailerOption[];
  selected_size?: string;
};

type EventData = {
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  product: TrackableProduct;
  retailerId?: string;
  retailers: RetailerOption[];
  selectedSize?: string;
};

class RetailerInteractionEvent extends InteractionEvent<
  EventData,
  RetailerTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'retailer';
  }

  protected getTargetProperties(): RetailerTargetProperties {
    return {
      product_id: this.data.product.product_id?.toString(),
      retailer_id: this.data.retailerId,
      retailers: this.data.retailers.map(toWireRetailerOption),
      selected_size: this.data.selectedSize
    };
  }
}

export default RetailerInteractionEvent;
